<template>
  <FormTemplate>
    <template v-slot:form-body>
      <v-form ref="formCollection" @submit.prevent="saveForm">
        <v-row>
          <v-col cols="12" md="3">
            <label for="title">Nombre del Libro</label>
          </v-col>

          <v-col cols="12" md="9" class="pb-0">
            <v-text-field
              id="title"
              v-model="book.title"
              outlined
              dense
              placeholder="Libro"
              :rules="required"
            ></v-text-field>
          </v-col>

          <v-col cols="12">
            <label for="description">Descripción</label>
          </v-col>

          <v-col cols="12" class="pb-0">
            <v-textarea
              id="description"
              v-model="book.description"
              outlined
              dense
              placeholder="Descripción de la collección"
              rows="4"
              :rules="required"
            ></v-textarea>
          </v-col>

          <v-col cols="12" md="3">
            <label for="buy_url">URL</label>
          </v-col>

          <v-col cols="12" md="9" class="pb-0">
            <v-text-field
              id="buy_url"
              v-model="book.buy_url"
              outlined
              dense
              placeholder="URL de la tienda"
              :rules="required"
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="3">
            <label for="icon">Imagen de portada</label>
          </v-col>

          <v-col cols="12" md="9" class="pb-0">
            <v-file-input
              id="icon"
              v-model="image"
              outlined
              prepend-icon=""
              dense
              placeholder="Elige una imagen"
              @change="onFileChange"
            ></v-file-input>
          </v-col>

          <v-col cols="12" md="3">
            <label for="id_collection">Collección</label>
          </v-col>

          <v-col cols="12" md="9" class="pb-0">
            <v-select
              id="id_collection"
              v-model="book.id_collection"
              outlined
              dense
              placeholder="Collección"
              :items="collections"
              item-text="title"
              item-value="id"
            ></v-select>
          </v-col>

          <v-col offset-md="3" cols="9">
            <v-btn type="submit" :disabled="loading" :loading="loading" color="primary"> Guardar </v-btn>
            <v-btn type="reset" @click="reset" class="mx-2" outlined> Limpiar </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </template>
  </FormTemplate>
</template>

<script>
import FormTemplate from '@/components/forms/FormTemplate.vue'
import { loadAPIImage } from '@/utils/images'

export default {
  components: {
    FormTemplate,
  },
  props: {
    bookEdited: Object,
    loading: Boolean,
    collections: Array,
  },
  data() {
    return {
      required: [v => !!v || 'Requerido'],
      url: '',
      image: null,
      book: this.bookEdited
        ? { ...this.bookEdited }
        : {
            text: '',
            urlText: '',
            description: '',
          },
    }
  },
  methods: {
    validateForm() {
      return this.$refs.formCollection.validate()
    },
    reset() {
      this.book.icon = null
      this.book.text = ''
      this.book.urlText = ''
      this.book.description = ''
      this.$refs.formCollection.resetValidation()
    },
    saveForm() {
      if (!this.validateForm()) return
      if (this.bookEdited) {
        let DTO = { ...this.book }

        if (this.image) {
          DTO = {
            ...DTO,
            file_book: this.image,
          }
        }
        // // console.log('actualizar', DTO)
        this.$emit('beforeUpdate', DTO)
      } else {
        const DTO = { ...this.book, file_book: this.image }
        // // console.log('crear', DTO)
        this.$emit('beforeCreate', DTO)
      }
    },
    loadImage(src) {
      return loadAPIImage(src)
    },
    onFileChange(e) {
      if (!e) return
      this.url = URL.createObjectURL(e)
    },
  },
}
</script>

<style lang="scss" scoped>
.icon-service {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background: #00aca0;
  padding: 20px;
}

.icon-service img {
  max-width: 80px;
  max-height: 80px;
}

.center-sub-items {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
